import { Profile } from "../../models/Profile";

export type ProfileActions =
    | { type: "profile/fetch-success"; data: Profile }
    | { type: "profile/update-success"; data: Profile };

export const TimezoneMapping = {
    Alaska: "US/Alaska",
    Pacific: "US/Pacific",
    Mountain: "US/Mountain",
    Central: "US/Central",
    Eastern: "US/Eastern",
    Hawaiian: "US/Hawaii",
};

export type Timezone =
    | "Alaska"
    | "Pacific"
    | "Mountain"
    | "Central"
    | "Eastern"
    | "Hawaiian";
